module.exports = __webpack_public_path__ + "static/user-03-bf2990022e89406c9cf18dacd73d4ae1.png";